import { render, staticRenderFns } from "./TypesOfRewards.vue?vue&type=template&id=a0c19ccc&scoped=true"
import script from "./TypesOfRewards.vue?vue&type=script&lang=js"
export * from "./TypesOfRewards.vue?vue&type=script&lang=js"
import style0 from "./TypesOfRewards.vue?vue&type=style&index=0&id=a0c19ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c19ccc",
  null
  
)

export default component.exports